import { Order } from '../BookingsCalendarTypes';

const trimmed = (value?: string): string => (value || '').trim();

export const formatKeyPickupAddress = (order: Order): string =>
    [
        trimmed(order.keyPickupAddress),
        [order.keyPickupZip, order.keyPickupCity].map(trimmed).filter(Boolean).join(' ')
    ]
        .filter(Boolean)
        .join(', ');
